/*
  --------------------
  ▼
  ・
  --------------------
*/
$(document).ready(function() {
  // --------------------
  // 
  // --------------------
  if ($('.swiper').length) {
    const mediaQuery = window.matchMedia('(min-width: 769px)');
    let voiceSwiper = null;
    let flag = false;

    const checkBreakpoint = (m) => {
      if (m.matches && !flag) {
        // 初期化
        flag = true;
        initSwiper();
      } else if (!m.matches && voiceSwiper && flag) {
        // スライダー削除
        flag = false;
        voiceSwiper.destroy(false, true);
      }
    };

    const initSwiper = () => {
      voiceSwiper = new Swiper('.swiper', {
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 'auto',
        spaceBetween: 60,
        speed: 600,
        centeredSlides: true,

        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
          waitForTransition: false,
        },

        pagination: {
          el: '.voice .swiper-pagination',
          clickable: true,
        },

        breakpoints: {
          // ブレークポイント
          768: {
            // 画面幅600px以上で適用
            slidesPerView: 1.5,
          },
        },
      });

      let swiper = document.querySelector('.swiper');

      swiper.addEventListener('mouseenter', function () {
        voiceSwiper.autoplay.stop();
      });

      swiper.addEventListener('mouseleave', function () {
        voiceSwiper.autoplay.start();
      });
    };

    window.addEventListener('resize', function () {
      checkBreakpoint(mediaQuery);
    });
    checkBreakpoint(mediaQuery);
  }
});
